export default __webpack_public_path__ + "static/media/redeem_icon.c0734807.svg";